/**
 * Lauf-Liste (Review-Queue Seite 1). Pollt alle 4s, solange mindestens ein
 * Run der aktuellen Antwort aktiv ist — Terminal-Stop-Muster identisch zu
 * `useListingAudits` (`hooks/useListingBuilder.ts:84-93`).
 */

import { useQuery } from '@tanstack/react-query'

import { listRuns } from '@/lib/api/channel-content-bulk'

import { isRunActive, textRunKeys } from './runStatus'

export function useContentRuns(page: number) {
  return useQuery({
    queryKey: textRunKeys.runs(page),
    queryFn: () => listRuns(page),
    refetchInterval: (query) =>
      (query.state.data?.runs ?? []).some((run) => isRunActive(run.status)) ? 4000 : false,
  })
}
